import { parse } from 'date-fns';
import { DiscountType } from '@ibk/shared-types';
import { formatCurrency } from '@ibk/shared-utils';
import { ReleaseType, } from '../types';
import { getUnformatedValue } from './beneficiaryUtils';
import { applyMask, DEFAULT_CURRENCY_VALUE } from './maskUtils';
const ACCRUAL_PERIOD_YM = /^\d{4}-\d{2}$/;
export function parseAccrualPeriodToCompetenceDate(accrualPeriod) {
    if (accrualPeriod == null || accrualPeriod === '') {
        return undefined;
    }
    if (!ACCRUAL_PERIOD_YM.test(accrualPeriod)) {
        return undefined;
    }
    return parse(`${accrualPeriod}-01`, 'yyyy-MM-dd', new Date());
}
function resolveGlobalValueFromProduct(release, product) {
    if (!product) {
        return DEFAULT_CURRENCY_VALUE;
    }
    if (release === ReleaseType.DAILY) {
        if (product.amountDaily != null) {
            return formatCurrency(product.amountDaily);
        }
        return DEFAULT_CURRENCY_VALUE;
    }
    if (product.baseValue != null) {
        return formatCurrency(product.baseValue);
    }
    return DEFAULT_CURRENCY_VALUE;
}
export function mapRechargeDetailToFormData(detail, product) {
    const voucher = detail.vouchers?.[0];
    if (!voucher)
        return {};
    const discountType = voucher.discountType ?? DiscountType.NO_DISCOUNT;
    const discountValueRaw = voucher.discountValue != null ? String(Math.round(voucher.discountValue * 100)) : '';
    const hasPerBeneficiaryDiscount = voucher.beneficiaries?.some(b => b.discountValue != null && b.discountValue > 0) ?? false;
    const isIndividualDiscount = (voucher.isIndividualDiscount ?? false) || hasPerBeneficiaryDiscount;
    const release = voucher.releaseType ?? ReleaseType.MONTHLY;
    const globalValue = resolveGlobalValueFromProduct(release, product);
    const amountDaily = release === ReleaseType.DAILY ? (product?.amountDaily ?? voucher.amountDaily) : voucher.amountDaily;
    const accrualCompetenceDate = parseAccrualPeriodToCompetenceDate(detail.accrualPeriod);
    return {
        ...(accrualCompetenceDate ? { competenceDate: accrualCompetenceDate } : {}),
        voucherTypeId: voucher.voucherTypeId,
        voucherType: voucher.voucherTypeDescription,
        rechargeType: detail.type,
        isIndividualDiscount,
        discountType,
        payrollDeduction: discountType !== DiscountType.NO_DISCOUNT,
        discountValue: discountValueRaw ? applyMask(discountValueRaw, discountType) : undefined,
        releaseType: release,
        globalValue,
        amountDaily,
        rechargeDayType: voucher.rechargeDayType,
        rechargeDay: voucher.rechargeDay,
        selectedBeneficiaries: voucher.beneficiaries?.length ?? 0,
        selectedBeneficiariesList: voucher.beneficiaries?.map(b => {
            const isDaily = voucher.releaseType === ReleaseType.DAILY;
            if (isDaily) {
                return {
                    beneficiaryId: b.id,
                    daysQuantity: b.daysQuantity,
                    discountValue: b.discountValue,
                    value: b.daysQuantity ? b.daysQuantity * getUnformatedValue(globalValue) : 0,
                };
            }
            return {
                beneficiaryId: b.id,
                value: b.value,
                discountValue: b.discountValue,
            };
        }),
    };
}
export function mapRechargeDetailToSimulateRequest(detail, product) {
    const voucher = detail.vouchers?.[0];
    if (!voucher)
        return { vouchers: [] };
    const voucherPayload = {
        voucherTypeId: voucher.voucherTypeId,
        discountType: voucher.discountType,
        discountValue: voucher.discountValue,
        rechargeDayType: voucher.rechargeDayType,
        rechargeDay: voucher.rechargeDay,
        releaseType: voucher.releaseType ?? ReleaseType.MONTHLY,
        isIndividualDiscount: voucher.isIndividualDiscount ?? false,
        beneficiaries: voucher.beneficiaries?.map(b => {
            const isDaily = voucher.releaseType === ReleaseType.DAILY;
            if (isDaily) {
                return {
                    beneficiaryId: b.id,
                    daysQuantity: b.daysQuantity,
                    discountValue: b.discountValue,
                };
            }
            return {
                beneficiaryId: b.id,
                value: b.value,
                discountValue: b.discountValue,
            };
        }),
    };
    if (voucher.releaseType === ReleaseType.DAILY) {
        voucherPayload.amountDaily = product?.amountDaily ?? voucher.amountDaily;
    }
    return { vouchers: [voucherPayload], accrualPeriod: detail.accrualPeriod ?? undefined };
}
